<button
  class="w-100 pointer-events-none webkit-tap-highlight-color-transparent d-flex"
  [ngClass]="[
    btnType,
    isAllowedGlobalStyling ? globalStylingClass : '',
    isAllowedGlobalStyling && icon ? 'with-icon' : ''
  ]"
  (click)="actionTrigger(btnType)"
  [disabled]="disabled"
  [ngStyle]="!isAllowedGlobalStyling ? contentStyle : {}"
>
  @if(icon){
  <mat-icon [ngStyle]="iconSize" [svgIcon]="icon"></mat-icon>
  }
  <span [innerHTML]="text"></span>
</button>
